import { render } from "./loginPhone.vue?vue&type=template&id=7ccf88b0"
import script from "./loginPhone.vue?vue&type=script&lang=js"
export * from "./loginPhone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__